<nav id="footer" class="footbar">
  <div class="background-border-grey">
    <div class="col-12 padding-0 margin-0 desktop">
      <div class="col-12 padding-0 margin-0 row">
        <div class="col-md-3 hidden-lg-down margin-auto text-center">
          <img
            src="/assets/images/white-logicon.svg"
            alt="devere-group-logo"
            width="auto"
            height="auto"
            />
          </div>
          <div class="col-md-6 hidden-lg-down margin-auto text-center">
            @if (template) {
              <p
                [innerHTML]="template | sanitizeHtml"
                class="template margin-auto"
              ></p>
            }
          </div>
          <div class="col-md-3 hidden-lg-down margin-auto text-center">
            <ul class="footer-menu">
              @for (footerMenuItem of footerMenu; track footerMenuItem) {
                <li
                  [class.active]="footerMenuItem.name === 'Policies'"
                  >
                  <a href="{{ footerMenuItem.href }}">{{ footerMenuItem.name }}</a>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
      <div class="col-12 padding-0 margin-0 mobile">
        <div class="col-12 margin-auto text-center">
          <img
            src="/assets/images/white-logicon.svg"
            alt="devere-group-logo"
            width="50px"
            height="50px"
            />
          </div>
          <div class="col-12 margin-auto text-center">
            <ul class="social_list">
              <li class="adviser">
                <a
                  href="https://www.devere-group.com/#elementor-action%3Aaction%3Dpopup%3Aopen%26settings%3DeyJpZCI6IjIwNiIsInRvZ2dsZSI6dHJ1ZX0%3D"
                  >Speak to an Adviser</a
                  >
                </li>
                @for (socialItem of socialMenu; track socialItem) {
                  <li class="socialItem">
                    <a [attr.aria-label]="socialItem.name" href="{{ socialItem.href }}">
                      <i class="{{ socialItem.iconName }}"></i>
                    </a>
                  </li>
                }
              </ul>
              @if (template) {
                <p
                  [innerHTML]="template | sanitizeHtml"
                  class="template margin-auto"
                ></p>
              }
            </div>
            <div class="col-12 margin-auto text-center">
              <ul class="footer-menu">
                @for (footerMenuItem of footerMenu; track footerMenuItem) {
                  <li
                    [class.active]="footerMenuItem.name === 'Policies'"
                    >
                    <a href="{{ footerMenuItem.href }}">{{ footerMenuItem.name }}</a>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      </nav>
